module.exports = __webpack_public_path__ + "img/gift4-01-c03-t2.0633b778.png";